import Cookies from 'js-cookie';

export const isRunningInIframe = () => {
    try {
        return window.self !== window.top;
    } catch (e) {
        // An exception usually indicates a cross-origin iframe scenario.
        return true;
    }
};

export const REMIND_ME_LATER_COOKIE_NAME = 'eula_remind_me_later';
export const REMIND_ME_LATER_COOKIE_VALUE = '1';

export const isRemindMeLaterActive = () => {
    const cookieValue = Cookies.get(REMIND_ME_LATER_COOKIE_NAME);
    return cookieValue !== undefined;
};

export const isEmailCampaign = (location: Location) => {
    const searchFromHash = location.hash.split('?')[1];
    const urlParamsFromHash = new URLSearchParams(searchFromHash && `?${searchFromHash}`);
    const channelFromHash = urlParamsFromHash.get('channel');

    const urlParams = new URLSearchParams(location.search);
    const channelFromSearch = urlParams.get('channel');

    return channelFromHash === 'email_campaign' || channelFromSearch === 'email_campaign';
};

export const getChannelFromLocation = (location: Location) => {
    return isEmailCampaign(location) ? 'EMAIL_CAMPAIGN' : 'RIO_PLATFORM';
};

const typo3SupportedLanguages = [
    'de',
    'en',
    'bg',
    'dk',
    'et',
    'fi',
    'fr',
    'gr',
    'it',
    'hr',
    'lv',
    'lt',
    'nl',
    'pl',
    'pt',
    'ro',
    'se',
    'sl',
    'sk',
    'es',
    'cz',
    'hu',
];

export const mapLocaleToTypo3Language = (locale: string | undefined) => {
    const language = locale?.split('-')[0] ?? 'en';
    return typo3SupportedLanguages.includes(language) ? language : 'en';
};

export const iframeMessageType = {
    PAGE_WITH_CONTENT_LOADED: 'PAGE_WITH_CONTENT_LOADED',
    PAGE_WITHOUT_CONTENT_LOADED: 'PAGE_WITHOUT_CONTENT_LOADED',
    EULA_STATUS_RECEIVED: 'EULA_STATUS_RECEIVED',
    REMIND_ME_LATER_COOKIE_FOUND: 'REMIND_ME_LATER_COOKIE_FOUND',
} as const;
export type IframeMessageType = (typeof iframeMessageType)[keyof typeof iframeMessageType];

// biome-ignore lint/suspicious/noExplicitAny: keep interface flexible
export const sendMessageToParent = ({ type, payload }: { type: IframeMessageType; payload?: any }) => {
    if ('parentIFrame' in window) {
        window.parentIFrame.sendMessage({ type: type, payload: payload }, '*');
    }
};
